import React from "react";
import { useTranslation } from "react-i18next";

export default function TermsOfService() {
  const { t } = useTranslation();
  return (
    <div>
      <h1 className="text-4xl font-bold mb-6">{t('terms.title')}</h1>

      <div className="prose dark:prose-invert space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            {t('terms.lastUpdated')}
          </h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('terms.intro')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('terms.section1Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('terms.section1Text')}
          </p>
          <ul className="list-disc list-inside space-y-2 text-raya-text-primary/90 font-medium mt-2">
            <li>{t('terms.license1')}</li>
            <li>{t('terms.license2')}</li>
            <li>{t('terms.license3')}</li>
            <li>{t('terms.license4')}</li>
            <li>{t('terms.license5')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('terms.section2Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('terms.section2Text')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('terms.section3Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('terms.section3Text')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">
            {t('terms.section4Title')}
          </h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('terms.section4Text')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('terms.section5Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('terms.section5Text')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('terms.section6Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('terms.section6Text')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('terms.section7Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('terms.section7Text')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('terms.section8Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('terms.section8Text')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">{t('terms.section9Title')}</h2>
          <p className="text-raya-text-primary/90 font-medium">
            {t('terms.section9Text')}
          </p>
        </section>
      </div>
    </div>
  );
}
